import http from '@/util/http';

export default {
    getDataBasicStatus() {
        return http.get('/DataRoaming/api/getDataBasicStatus');
    },
    getRoamServiceList() {
        return http.get('/DataRoaming/api/getRoamServiceList');
    },
    switchDataRoaming() {
        return http.post('/DataRoaming/api/switchDataRoaming');
    },
    getCountryMap() {
        return http.get('/DataRoaming/api/getCountryMap');
    },
    removeDateRoamingItem(ftRemoveDataRoamingItem) {
        return http.post('/DataRoaming/api/removeDateRoamingItem', ftRemoveDataRoamingItem );
    },
    addRoamItem(ftAddRoamingItem) {
        return http.post('/DataRoaming/api/addRoamItem', ftAddRoamingItem)
    },
    retrieveVoiceBasicStatus4Roaming() {
        return http.post('/DataRoaming/api/retrieveVoiceBasicStatus4Roaming');
    },
    changeVoiceBasicStatus4Roaming(serviceID, ApplyStatusARW, ApplyStatusCDW) {
        return http.get('/DataRoaming/api/changeVoiceBasicStatus4Roaming', { params: { serviceID, ApplyStatusARW, ApplyStatusCDW } });
    },
    getCountryRoamingItem() {
        return http.get('/DataRoaming/api/getCountryRoamingItem');
    },
    getRoamSIMType() {
        return http.get('/DataRoaming/api/getRoamSIMType');
    }
}


// WEBPACK FOOTER //
// ./src/api/dataRoaming/dataRoamingApi.js